/** @jsx jsx */

import React, { useContext, useRef } from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';

import getTopics from 'services/apiHelpers/getTopics';
import TopicPanel from './TopicPanel';

import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';

const TopicPortalContainer = props => {
  const context = useContext(interactionContext);

  const topics = getTopics();
  const displayedTopics = topics.filter((t: any, index: number) => {
    return index > 0 && t.props.hiddenFromPortal !== true;

    // leaving this as a note of what was
    // return topic.meta?.subType !== 'TopicPortal'
  });

  const { lockDown } = context.props;

  const itemsSeen = useRef(
    unlockInteraction(context.id, (displayedTopics as any).length)
  );

  const updateTopicComplete = id => {
    // if (lockDown === 0) {
    //   return;
    // }

    itemsSeen.current(id);
  };

  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin: 12px 0 12px 0;
        `}
      >
        {displayedTopics.map((t: any, index: number) => {
          return (
            <TopicPanel
              key={t.id}
              topic={t}
              updateTopicComplete={updateTopicComplete}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TopicPortalContainer;
